import React, {useContext, useEffect, useState} from 'react';
import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {Lobby, SlotLobby} from "../../app/lobby/lobby";
import {gameType} from "../provider/lobby_modal_provider";


export default function LobbyModalContainer({show, setShow, vendor, type}:
                            {show: boolean, setShow: any, vendor: string, type: gameType}){
    function handleClose(){
        setShow(false)
    }
    return (
        <Modal show={show}
               onHide={handleClose}
               className={`lobby-modal`}
        >

            <Modal.Body>
                <span className={'modal-close-btn'}
                      onClick={handleClose}>
                            <FontAwesomeIcon icon={faXmark}/>
                </span>
                <Lobby vendor={vendor} type={type} handleClose={handleClose}/>
            </Modal.Body>
        </Modal>
    )
}
